var styleDataHash = "a86616e0";
const injectCss = (() => {
  var css = `.qn8MT{display:flex;flex-direction:row;gap:6px;height:48px;min-height:48px;overflow:visible;white-space:nowrap;width:100%}.qn8MT>*{flex-shrink:0}._834QP{display:flex;position:relative}._834QP .QZRNk{opacity:0;position:absolute;right:0;top:0;transform:translate(50%,-50%);transition:opacity .2s ease-in-out}._834QP:focus-within .QZRNk,._834QP:hover .QZRNk{opacity:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var attachment_bar_default = {
  "root": "qn8MT",
  "attachmentWrapper": "_834QP",
  "removeButton": "QZRNk"
};
export {
  attachment_bar_default as default,
  injectCss
};
//# sourceMappingURL=attachment-bar-scss.js.map
